<template>
  <div>
    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">
          {{ sidebarTitle }}
        </h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hideSideBar()"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row>
          <b-col md="12">
            <b-form-group
              label="Vendor Name"
              invalid-feedback="Vendor name is required."
              ref="name"
            >
              <b-form-input
                placeholder="Enter vendor name"
                ref="name"
                v-model="myObj.name"
                @blur="CheckName()"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group
              label="Mobile Number"
              invalid-feedback="Mobile number is required."
              ref="mobile"
            >
              <vue-tel-input
                v-model="myObj.mobile_number"
                :dropdownOptions="dropOptions"
                :defaultCountry="$store.state.countryCode"
                @input="isValidMobile"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group
              label="Email"
              invalid-feedback="Please enter a valid email."
            >
              <b-form-input
                type="email"
                placeholder="Enter email address"
                v-model="myObj.email"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group label="NTN (National Tax Number)">
              <b-form-input placeholder="Enter NTN" v-model="myObj.ntn" />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group label="CNIC">
              <b-form-input
                placeholder="Enter CNIC (00000-0000000-0)"
                v-model="myObj.cnic"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group label="Tax Status">
              <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :clearable="false"
                :options="taxStatusOptions"
                :reduce="(opt) => opt.value"
                label="text"
                v-model="myObj.taxStatus"
                placeholder="Select tax status"
              />
            </b-form-group>
          </b-col>

          <!-- <b-col md="12">
            <b-form-group label="Vendor Type">
              <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :clearable="false"
                :options="vendorTypeOptions"
                :reduce="(opt) => opt.value"
                label="text"
                v-model="myObj.vendor_type"
                placeholder="Select vendor type"
              />
            </b-form-group>
          </b-col> -->

          <b-col md="12">
            <b-form-group label="Address">
              <b-form-textarea
                placeholder="Enter complete address"
                v-model="myObj.address"
                rows="3"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <div class="d-flex justify-content-between">
              <label class="bv-no-focus-ring col-form-label pt-0"
                >Documents</label
              >
            </div>
            <div class="d-flex flex-wrap">
              <div
                class="border-dashed d-flex flex-column justify-content-center align-items-center cursor-pointer rounded mr-50 mb-1"
                style="width: 85px; height: 85px"
                @click="!docLoading && $refs.vendorDocs.click()"
              >
                <b-spinner
                  v-if="docLoading"
                  small
                  label="Loading..."
                  variant="primary"
                />
                <feather-icon
                  v-else
                  icon="PlusIcon"
                  size="34"
                  class="text-primary"
                />
              </div>
              <div
                class="border-dashed d-flex flex-column justify-content-center align-items-center cursor-pointer rounded mr-50 mb-1"
                style="width: 85px; height: 85px; position: relative"
                v-for="(file, index) in docList"
                :key="index"
                @click="openFile(file)"
              >
                <b-avatar
                  size="20"
                  variant="primary"
                  style="position: absolute; top: -5px; right: -5px"
                  button
                  @click.stop="removeDoc(index)"
                >
                  <feather-icon icon="XIcon" />
                </b-avatar>
                <feather-icon
                  :icon="isImage(file) ? 'ImageIcon' : 'FileTextIcon'"
                  size="30"
                  class="text-primary"
                />
              </div>

              <input
                type="file"
                id="vendorDocs"
                hidden
                ref="vendorDocs"
                multiple
                @change="addDoc()"
                accept="image/*,.pdf"
              />
            </div>
          </b-col>

          <b-col md="12">
            <b-form-group label="Note">
              <b-form-textarea
                placeholder="Enter any additional note"
                v-model="myObj.note"
                rows="3"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-button
              variant="success"
              @click="Add()"
              :disabled="request"
              block
            >
              <b-spinner v-if="request" small type="grow" />
              <span v-else> {{ sidebarButton }} </span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-sidebar>

    <b-card>
      <b-row class="mt-1">
        <b-col xl="2" lg="3" md="4" sm="12" cols="12">
          <b-button @click="AddOpen()" block variant="primary">
            <feather-icon icon="PlusIcon" class="mr-50" />
            <span class="align-middle">Add Vendor</span>
          </b-button>
        </b-col>

        <b-col
          class="mt-lg-0 mt-md-0 mt-sm-1 mt-1"
          xl="10"
          lg="9"
          md="8"
          sm="12"
          cols="12"
        >
          <b-form-group class="">
            <b-input-group>
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>

              <b-form-input
                v-model="searchQuery"
                placeholder="Search vendors..."
                @keyup.enter="loadSearch()"
              />
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>

      <b-table
        class="mt-1"
        ref="selectableTable"
        :items="filters"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :busy="dataLoading"
        responsive
        show-empty
      >
        <template #table-busy>
          <div class="d-flex justify-content-center mb-3 mt-5">
            <b-spinner
              style="width: 3rem; height: 3rem"
              type="grow"
              variant="primary"
              label="Spinning"
            ></b-spinner>
          </div>
        </template>

        <template #cell(name)="data">
          <b-badge variant="light-primary">
            {{ data.item.name }}
          </b-badge>
        </template>

        <template #cell(taxStatus)="data">
          <b-badge
            :variant="
              data.item.taxStatus === 'filer' ? 'light-success' : 'light-danger'
            "
          >
            {{
              data.item.taxStatus ? data.item.taxStatus.toUpperCase() : "N/A"
            }}
          </b-badge>
        </template>

        <!-- <template #cell(vendor_type)="data">
          <b-badge variant="light-secondary">
            {{ data.item.vendor_type || "N/A" }}
          </b-badge>
        </template> -->

        <template #head(actions)="data">
          <div class="text-center">
            <span>{{ data.label }}</span>
          </div>
        </template>

        <template #cell(actions)="data">
          <div class="text-center">
            <b-button
              variant="primary"
              v-b-tooltip.hover.left
              title="Edit"
              class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0"
              @click="Edit(data.item)"
            >
              <feather-icon icon="EditIcon" class="" />
            </b-button>

            <b-button
              variant="outline-danger"
              v-b-tooltip.hover.right
              title="Delete"
              class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0"
              @click="Delete(data.item.id)"
            >
              <feather-icon icon="Trash2Icon" />
            </b-button>
          </div>
        </template>
      </b-table>

      <b-col cols="12" class="d-flex align-items-center justify-content-center">
        <b-pagination
          v-model="currentPage"
          :total-rows="filters.length"
          :per-page="perPage"
          first-number
          last-number
          class="mb-0 mt-1 mt-sm-0"
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </b-col>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BLink,
  BBadge,
  BPagination,
  BImg,
  VBTooltip,
  BFormCheckbox,
  BFormGroup,
  BForm,
  BMediaAside,
  BSpinner,
  BSidebar,
  VBToggle,
  BInputGroupPrepend,
  BFormTextarea,
  BInputGroup,
  BDropdown,
  BDropdownItem,
  BFormFile,
  BAvatar,
} from "bootstrap-vue";
import { mapActions } from "vuex";
import vSelect from "vue-select";
import { getUploadedPaths, uploadToMySkool } from "@/utils/gdriveUpload";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BLink,
    BBadge,
    BPagination,
    BImg,
    BFormCheckbox,
    BFormGroup,
    BForm,
    BMediaAside,
    BSpinner,
    BSidebar,
    BInputGroupPrepend,
    BFormTextarea,
    BInputGroup,
    BDropdown,
    BDropdownItem,
    vSelect,
    BFormFile,
    BAvatar,
  },
  directives: {
    "b-tooltip": VBTooltip,
    "b-toggle": VBToggle,
  },
  data() {
    return {
      rights: {
        view: true,
        add: true,
        edit: true,
        delete: true,
      },
      request: false,
      visibility: false,
      sidebarTitle: "Add Vendor",
      sidebarButton: "Save",
      buttonIcon: "PlusIcon",
      dataLoading: false,
      searchQuery: "",
      currentPage: 1,
      perPage: 30,
      items: [],
      myObj: {
        id: 0,
        name: "",
        mobile_number: "",
        email: "",
        ntn: "",
        cnic: "",
        taxStatus: "",
        vendor_type: "",
        address: "",
        documents: null,
        note: "",
        campusID: this.$store.state.userData.cId,
      },
      fields: [
        { label: "Name", key: "name" },
        { label: "Mobile", key: "mobile_number" },
        { label: "Email", key: "email" },
        // { label: "Tax Status", key: "taxStatus" },
        // { label: "Vendor Type", key: "vendor_type" },
        { key: "actions", label: "Actions" },
      ],
      taxStatusOptions: [
        { text: "Filer", value: "filer" },
        { text: "Non-Filer", value: "non-filer" },
        { text: "Not Applicable", value: "not-applicable" },
      ],
      vendorTypeOptions: [
        { text: "Service Provider", value: "service-provider" },
        { text: "Product Supplier", value: "product-supplier" },
        { text: "Equipment Supplier", value: "equipment-supplier" },
        { text: "Food Supplier", value: "food-supplier" },
        { text: "Transportation", value: "transportation" },
        { text: "Other", value: "other" },
      ],
      dropOptions: {
        disabled: false,
        showDialCodeInList: true,
        showFlags: true,
      },
      docLoading: false,
      docList: [],
    };
  },
  computed: {
    filters: function () {
      return this.items.filter((vendor) => {
        return (
          vendor.name.toLowerCase().match(this.searchQuery.toLowerCase()) ||
          vendor.mobile_number
            .toLowerCase()
            .match(this.searchQuery.toLowerCase()) ||
          (vendor.email &&
            vendor.email.toLowerCase().match(this.searchQuery.toLowerCase()))
        );
      });
    },
  },
  async created() {
    this.LoadData();
  },
  methods: {
    ...mapActions({ get: "get", post: "post", put: "put", delete: "delete" }),

    async LoadData() {
      this.dataLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "Vendors?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.items = await this.get(obj);

      this.dataLoading = false;
    },

    AddOpen() {
      this.myObj = {
        id: 0,
        name: "",
        mobile_number: "",
        email: "",
        ntn: "",
        cnic: "",
        taxStatus: "",
        vendor_type: "",
        address: "",
        documents: null,
        note: "",
        campusID: this.$store.state.userData.cId,
      };
      this.docList = [];
      this.visibility = true;
      this.sidebarTitle = "Add Vendor";
      this.sidebarButton = "Save";
      var elem = this.$refs["name"];
      if (elem) elem.state = undefined;
      var elem = this.$refs["mobile"];
      if (elem) elem.state = undefined;
    },

    Edit(item) {
      this.myObj = { ...item };
      this.docList = [];
      if (item.documents) {
        this.docList = item.documents.split(",");
      }
      this.visibility = true;
      this.sidebarTitle = "Edit Vendor";
      this.sidebarButton = "Update";
      var elem = this.$refs["name"];
      if (elem) elem.state = undefined;
      var elem = this.$refs["mobile"];
      if (elem) elem.state = undefined;
    },

    CheckName() {
      var elem = this.$refs["name"];
      if (this.myObj.name.trim() == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },

    isValidMobile(s, e) {
      var elem = this.$refs["mobile"];
      if (this.myObj.mobile_number && e.valid) {
        elem.state = true;
        this.myObj.mobile_number = e.number;
        // console.log(this.myObj.mobile_number);
      } else {
        elem.state = false;
      }
    },
    CheckMobile() {
      var elem = this.$refs["mobile"];
      return elem.state;
    },

    hideSideBar() {
      this.visibility = false;
    },

    loadSearch() {
      // Trigger search functionality
      this.currentPage = 1;
    },

    async Add() {
      this.CheckName();

      if (this.CheckName() == false) {
        return this.$bvToast.toast("Please enter vendor name", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }

      if (this.CheckMobile() == false) {
        return this.$bvToast.toast("Please enter mobile number", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }

      if (this.myObj.id == 0) {
        // Add
        this.request = true;
        var status = await this.post({
          url:
            this.$store.state.domain +
            "Vendors?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          body: this.myObj,
          message: "Vendor added successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        this.request = false;
        this.visibility = false;
        if (status) this.LoadData();
      } else {
        // Edit
        this.request = true;
        var status = await this.put({
          url:
            this.$store.state.domain +
            "Vendors/" +
            this.myObj.id +
            "?db=" +
            this.$store.state.userData.db,
          body: this.myObj,
          message: "Vendor updated successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        this.request = false;
        this.visibility = false;
        if (status) this.LoadData();
      }
    },

    async Delete(id) {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });

      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "Vendors/" +
            id +
            "?db=" +
            this.$store.state.userData.db,
          body: null,
          message: "Vendor removed successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.LoadData();
      }
    },

    async addDoc() {
      if (this.$refs.vendorDocs.files.length > 0) {
        this.docLoading = true;
        try {
          const uploaded = await uploadToMySkool(this.$refs.vendorDocs.files);
          getUploadedPaths(uploaded).forEach((path) => {
            this.docList.push(path);
          });
          this.myObj.documents = this.docList.join(",");
        } catch (err) {
          console.log(err);
        } finally {
          this.docLoading = false;
        }
      }
    },

    openFile(url) {
      window.open(url, "_blank");
    },

    removeDoc(index) {
      this.docList.splice(index, 1);
      this.myObj.documents = this.docList.join(",");
    },

    isImage(url) {
      return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/i.test(url);
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
